import { PermissionLevels } from '@debbie/common/dist/index.js';
import { CaseStatus } from '@debbie/common/dist/cases/index.js';
import { TemplateType, TemplateGroupStates, TemplateState, } from '@debbie/common/dist/templates/index.js';
export const BASIC_THEME = {
    NAV_LEFT_WIDTH: 250,
    NAV_RIGHT_WIDTH: 300,
    NAV_TOP_HEIGHT: 60,
    SUB_MENU_HEIGHT: 60,
    COLOR_PRIMARY: '#200D54',
    COLOR_SECONDARY: '#FFFFFF',
    COLOR_ACCENT: '#7568F6',
    COLOR_GREY: '#A5A5A5',
    BACKGROUND: '#F1F4FB',
    DANGEROUS: '#D7615C',
    WARNING: '#ffc107',
    SUCCESS: '#53BA41',
    DARK_COLOR_SECONDARY: '#A2A2A2',
    SELECTED_BLUE: '#7568F6',
    STATUS_COLORS: {
        [CaseStatus.VERIFIED]: '#98D679',
        [CaseStatus.PENDING]: '#E5E56E',
        [CaseStatus.ENDED]: '#515D76',
    },
    STATE_COLORS: {
        [TemplateGroupStates.PUBLISHED_WIP]: '#515D76',
        [TemplateGroupStates.NEVER_PUBLISHED]: '#D07474',
        [TemplateGroupStates.WIP]: '#E5E56E',
        [TemplateState.DRAFT]: '#515D76',
        [TemplateState.PUBLISHED]: '#98D679',
        [TemplateState.VERSION]: '#E5E56E',
    },
    TYPE_COLORS: {
        [TemplateType.EMAIL]: '#ffc107',
        [TemplateType.LETTER]: '#08C',
        [TemplateType.SMS]: '#28a745',
        [TemplateType.AUTOCALL]: '#515D76',
        [TemplateType.EBOKS]: '#08C08C',
    },
    USER_TYPE_COLORS: {
        [PermissionLevels.superAdmin]: '#D07474',
        [PermissionLevels.admin]: '#D07474',
        [PermissionLevels.caseworker]: '#ffc107',
        [PermissionLevels.client]: '#08C',
        [PermissionLevels.alternativeContact]: '#08C',
        [PermissionLevels.debtor]: '#08C',
    },
    MEDIA_QUERY_MOBILE: 'screen and (max-width: 770px)',
    MEDIA_QUERY_NOT_MOBILE: 'screen and (min-width: 771px)',
    MEDIA_QUERY_TABLET: 'screen and (max-width: 992px)',
    MEDIA_QUERY_NOT_TABLET: 'screen and (min-width: 993px)',
    GRID_SPACING: 20,
    DATE_FORMAT: 'Do MMMM YYYY',
    DATE_FORMAT_SHORT: 'DD.MM.YY',
    DATE_FORMAT_LONG: 'Do MMMM YYYY, H:mm:ss',
};
const THEME = JSON.parse(JSON.stringify(BASIC_THEME));
export default THEME;
export const updateTheme = (newTheme) => Object.entries({ ...BASIC_THEME, ...newTheme }).map((r) => {
    // @ts-ignore
    if (r[1])
        THEME[r[0]] = r[1];
});
//# sourceMappingURL=theme.js.map